
import React from 'react'

import Auth from './pages/Auth/Auth';
import Login from './components/Secondary/Login';
import Register from './components/Secondary/Register';
import ResetSent from './components/Secondary/ResetSent';
import ResetPassword from './components/Secondary/ResetPassword';
import LandingPage from './pages/LandingPage/';
import AllProducts from './pages/AllProducts/';
import FavouritePage from './pages/FavouritePage/';
import ProductDetail from './pages/ProductDetail/ProductDetail';
import { BrowserRouter as Router, Switch, Route  } from 'react-router-dom'
import Cart from './pages/Cart/';
function App() {
  return (
    <div className="bg-gray-light min-h-screen w-full">
    <Router>
    <Switch>
   
    <Route exact path="/login" component={Login} />
     <Route exact path="/register" component={Register} />
     
     <Route exact path="/reset-password" component={ResetPassword} />
     <Route exact path="/reset-sent" component={ResetSent} />
     <Route exact path="/" component={LandingPage} />
     <Route exact path="/all-products" component={AllProducts} />
      <Route exact path="/cart" component={Cart} />
      <Route exact path="/fav" component={FavouritePage} />
      <Route exact path="/product/:id" component={ProductDetail} />
        
       
     
   </Switch>
 </Router>
 </div>
  )
}

export default App;
